module.exports = __webpack_public_path__ + "img/book_02.25df364d.jpg";